import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
    static targets = ['destroyField']

    declare readonly destroyFieldTarget: HTMLInputElement

    destroy() {
        this.destroyFieldTarget.setAttribute('value', 'true')
        this.element.setAttribute('style', 'display: none !important;')
    }
}
